import { FC } from 'react';
import styled from 'styled-components';
import Image from 'next/image';

type PlaceholderValue = 'blur' | 'empty';

export type GfxImage = {
  id?: string;
  layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive' | undefined;
  alt: string;
  src: string;
  quality?: number;
  className?: string;
  priority?: boolean;
  blurDataURL?: string;
  placeholder?: PlaceholderValue;
  objectFit?: 'none' | 'contain' | 'cover' | 'fill' | undefined;
  width?: number;
  height?: number;
  $horizontalPaddingMobile?: boolean | undefined;
  $maxHeightMobile?: boolean;
};

const GfxImage: FC<GfxImage> = ({
  layout,
  quality, // Default is 75
  src,
  width = 0,
  height = 0,
  objectFit,
  blurDataURL,
  placeholder = 'empty',
  alt,
  ...rest
}) => {
  if (!src) {
    return null;
  }
  const isLayoutFill = layout === 'fill';
  const isSvg = src.includes('.svg');

  const imageProps = {
    layout,
    ...rest,
    ...(isSvg && { unoptimized: true }),
    ...(placeholder === 'blur' && { blurDataURL: blurDataURL }),
    ...(objectFit !== 'none' && { style: { objectFit } }),
    ...(!isLayoutFill && { width: width, height: height })
  };

  return <Image src={src} placeholder={placeholder} alt={alt} quality={quality} {...imageProps} />;
};

export default styled(GfxImage)``;
